import 'react-native-get-random-values'
import { View } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { TailwindProvider } from 'tailwindcss-react-native';
import HomeScreen from './screens/HomeScreen';
import MainMenu from './screens/MainMenu';
import NextMatch from './screens/NextMatch';
import Roster from './screens/Roster';
import Clasification from './screens/Clasification';
import Market from './screens/Market';
import { useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import NewGame from './screens/NewGame';
import Help from './screens/Help';
import Profile from './screens/Profile';
import Special from './screens/Special';
import AssignBroom from './screens/AssignBroom';
import Configuration from './screens/Configuration';
import Statistics from './screens/Statistics';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorScreen from './screens/ErrorScreen';
import ListOfButtons from './screens/ListOfButtons';
import HallOfFame from './screens/HallOfFame';
import CupInfo from './screens/CupInfo';
import Grageas from './screens/Grageas';
import Credits from './screens/Credits';
import DownloadTeam from './screens/DownloadTeam';
import SendTeam from './screens/SendTeam';
import FriendsList from './screens/FriendsList';
import FriendProfile from './screens/FriendProfile';
import Objects from './screens/Objects';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { useState } from 'react';
import BestPlayers from './screens/BestPlayers';
import Tactics from './screens/Tactics';
import Online from './screens/Online';
import ComparePlayers from './screens/ComparePlayers';
import InGameStats from './screens/InGameStats';

const Stack = createNativeStackNavigator();

// Reducer function
const languageReducer = (state = 0, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return {
        ...state,
        language: action.language,
      };
    default:
      return state;
  }
};

// Create Redux store with Redux DevTools integration
const store = createStore(
  languageReducer
);

export default function App() {
  const readData = async () => {
    try {
      const jsonValue = await AsyncStorage.getItem('equipos')
      return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      if(value) {
        if(value === undefined || !value) return
        if(typeof value != "object") value = value != null ? JSON.parse(value) : null
        store.dispatch({ type: 'SET_LANGUAGE', language: value.settings.language });
      }
    })
  }
  readValue()

  useEffect(() => {
    readData();
  }, []);
  
  return (
    // style={{backgroundColor:"black"}}
    // para poder ver fallos en concreto en web, comentar errorboundary
    <Provider store={store}>
      {/* <ErrorBoundary FallbackComponent={ErrorScreen}> */}
        <View style={{flex:1}}>
          <View style={{ flex:1}}>
            <NavigationContainer>
              <TailwindProvider>
                <Stack.Navigator>
                  <Stack.Screen name="MainMenu" component={MainMenu} />
                  <Stack.Screen name="HomeScreen" component={HomeScreen} />
                  <Stack.Screen name="NextMatch" component={NextMatch} />
                  <Stack.Screen name="Roster" component={Roster} />
                  <Stack.Screen name="Clasification" component={Clasification} />
                  <Stack.Screen name="Market" component={Market} />
                  <Stack.Screen name="NewGame" component={NewGame} />
                  <Stack.Screen name="Help" component={Help} />
                  <Stack.Screen name="Profile" component={Profile} />
                  <Stack.Screen name="Special" component={Special} />
                  <Stack.Screen name="AssignBroom" component={AssignBroom} />
                  <Stack.Screen name="Configuration" component={Configuration} />
                  <Stack.Screen name="Statistics" component={Statistics} />
                  <Stack.Screen name="ListOfButtons" component={ListOfButtons} />
                  <Stack.Screen name="HallOfFame" component={HallOfFame} />
                  <Stack.Screen name="CupInfo" component={CupInfo} />
                  <Stack.Screen name="Grageas" component={Grageas} />
                  <Stack.Screen name="Credits" component={Credits} />
                  <Stack.Screen name="DownloadTeam" component={DownloadTeam} />
                  <Stack.Screen name="SendTeam" component={SendTeam} />
                  <Stack.Screen name="FriendsList" component={FriendsList} />
                  <Stack.Screen name="FriendProfile" component={FriendProfile} />
                  <Stack.Screen name="Objects" component={Objects} />
                  <Stack.Screen name="BestPlayers" component={BestPlayers} />
                  <Stack.Screen name="Tactics" component={Tactics} />
                  <Stack.Screen name="Online" component={Online} />
                  <Stack.Screen name="ComparePlayers" component={ComparePlayers} />
                  <Stack.Screen name="InGameStats" component={InGameStats} />
                </Stack.Navigator>
              </TailwindProvider>
            </NavigationContainer>
          </View>
          <View onClick={() => navigation.goBack()} />
        </View>
      {/* </ErrorBoundary> */}
      </Provider>
  );
}

